import classNames from 'classnames';
import { CSSProperties } from 'react';
import styles from 'styles/pages/chart/DHDiagnosisPlanEvaluation.module.scss';
import FormRadioBtn from 'components/common/forms/FormRadioBtn';
import FormAutoHeightTextarea from 'components/common/forms/FormAutoHeightTextarea';

type TProps = {
  categoryTitle: string;
  factorName: string;
  style?: CSSProperties;
  isRegister?: boolean;
};

const textareaStyle = {
  width: '100%',
  minHeight: '100px',
  padding: '12px 16px',
  border: 'none',
  marginLeft: '0',
};

const CategoryRow = ({
  categoryTitle,
  factorName,
  style,
  isRegister,
}: TProps) => {
  return (
    <>
      <tr className={styles.tr}>
        <td rowSpan={4} className={classNames(styles.category)} style={style}>
          {categoryTitle.split('\n').map((line, index) => (
            <p key={index}>{line}</p>
          ))}
        </td>
        <td className={styles.subtext}>Problem</td>
        <td className={styles.subtext}>Goals</td>
        <td rowSpan={4} className={styles.td_border_bottom}>
          <div className={styles.radio_btn_wrapper}>
            <FormRadioBtn
              labelText="달성"
              name={`${factorName}Evaluation`}
              value="달성"
              readOnly={!isRegister}
            />
            <FormRadioBtn
              labelText="부분달성"
              name={`${factorName}Evaluation`}
              value="부분달성"
              readOnly={!isRegister}
            />
            <FormRadioBtn
              labelText="미달성"
              name={`${factorName}Evaluation`}
              value="미달성"
              readOnly={!isRegister}
            />
          </div>
        </td>
      </tr>

      <tr>
        <td className={styles.td}>
          <FormAutoHeightTextarea
            textareaStyle={textareaStyle}
            name={`${factorName}Problem`}
            placeholder="텍스트 및 숫자를 입력해 주세요."
            readOnly={!isRegister}
          />
        </td>
        <td className={styles.td}>
          <FormAutoHeightTextarea
            textareaStyle={textareaStyle}
            name={`${factorName}Goals`}
            placeholder="텍스트 및 숫자를 입력해 주세요."
            readOnly={!isRegister}
          />
        </td>
      </tr>

      <tr>
        <td className={styles.subtext}>Risk Factor</td>
        <td className={styles.subtext}>Methods</td>
      </tr>

      <tr>
        <td className={styles.td_border_bottom}>
          <FormAutoHeightTextarea
            textareaStyle={textareaStyle}
            name={`${factorName}RiskFactor`}
            placeholder="텍스트 및 숫자를 입력해 주세요."
            readOnly={!isRegister}
          />
        </td>
        <td className={styles.td_border_bottom}>
          <FormAutoHeightTextarea
            textareaStyle={textareaStyle}
            name={`${factorName}Methods`}
            placeholder="텍스트 및 숫자를 입력해 주세요."
            readOnly={!isRegister}
          />
        </td>
      </tr>
    </>
  );
};

export default CategoryRow;
